import {
  Infer,
  any,
  array,
  boolean,
  enums,
  nullable,
  object,
  string,
} from "superstruct";
import { ModCfImage } from "components/Image/types";
import { ModCfTranslation } from "types/types";
import {
  contentToChildren,
  modelWithStringAndChildMarkdownRemark,
} from "utilities/validatoros/types";

export const ModCfSms = object({
  __typename: enums(["ContentfulSmsV2"]),
  contentful_id: string(),
  node_locale: string(),
  image: array(ModCfImage),
  textTop: nullable(modelWithStringAndChildMarkdownRemark("textTop")),
  textForm: nullable(modelWithStringAndChildMarkdownRemark("textForm")),
  hideForm: boolean(),
  hideFormMobile: boolean(),
  // TO DO: union(ModCfText, ModCfCustomHTML)
  content: nullable(any()),
  inputPhonePalcehoder: array(ModCfTranslation),
  inputPhoneValidationErrorMessege: array(ModCfTranslation),
  sendButtonLabel: array(ModCfTranslation),
  successSendMessage: nullable(
    modelWithStringAndChildMarkdownRemark("successSendMessage"),
  ),
  errorSendMessage: nullable(
    modelWithStringAndChildMarkdownRemark("errorSendMessage"),
  ),
  smsTemplateId: string(),
  // urlApiSms: string;
});

export const ModCfSmsProps = contentToChildren(ModCfSms);

export type CfSmsProps = Infer<typeof ModCfSmsProps>;
